import { useState, useEffect } from "react";
import { query, orderBy, limit, onSnapshot, where } from "firebase/firestore";
import { getChatType } from "../utils/utils";
export const useChatPreview = (chat, currentUserUid) => {
    const [preview, setPreview] = useState({ lastMessage: null, unreadCount: 0 });
    useEffect(() => {
        if (!chat.chatID)
            return;
        const messagesRef = getChatType(false, chat);
        const qLast = query(messagesRef, orderBy("date", "desc"), limit(1));
        const unsubLast = onSnapshot(qLast, (snapshot) => {
            var _a;
            const lastDoc = (_a = snapshot.docs[0]) === null || _a === void 0 ? void 0 : _a.data();
            setPreview(prev => (Object.assign(Object.assign({}, prev), { lastMessage: lastDoc || null })));
        });
        const qUnread = query(messagesRef, where("read", "==", false), where("sender.uid", "!=", currentUserUid));
        const unsubUnread = onSnapshot(qUnread, (snapshot) => {
            setPreview(prev => (Object.assign(Object.assign({}, prev), { unreadCount: snapshot.size })));
        });
        return () => {
            unsubLast();
            unsubUnread();
        };
    }, [chat.chatID, currentUserUid]);
    return preview;
};
